<template>
  <v-card :class="['bottom-sheet', { active: show }]">
    <v-icon @click="saveAndClose" color="white" class="closeBtn"
      >keyboard_backspace</v-icon
    >
    <div class="settings">
      <h2>Filter zur Vereinssuche</h2>
      <p>
        <v-icon color="green white--text">info</v-icon>Wenn du landesweit nach Vereinen
        suchst, dann werden die Vereinskarten im Matching von der niedrigsten zur
        höchsten Liga angezeigt.
      </p>

      <v-switch
        color="green"
        v-model="user_data.verband_filter"
        label="Filtern nach Region/Verband"
      ></v-switch>

      <label>Land</label>
      <v-autocomplete
        class="input"
        color="green"
        :items="$store.state.nationalities"
        item-text="item_text"
        item-value="id"
        v-model="user_data.search_nationality"
        solo
        attach
      ></v-autocomplete>

      <label v-if="user_data.verband_filter">Region/Verband</label>
      <v-select
        class="input"
        v-if="user_data.verband_filter"
        color="green"
        :items="$store.state.verband"
        v-model="user_data.search_verband"
        solo
      ></v-select>

      <label v-if="user_data.search_verband && user_data.verband_filter">Liga</label>
      <v-select
        v-if="user_data.search_verband && user_data.verband_filter"
        color="green"
        solo
        :items="$store.state.filter_leagues[user_data.search_verband]"
        item-text="league"
        item-value="league"
        v-model="searchLeague"
        multiple
      ></v-select>

      <div class="text-xs-center" style="width: 100%">
        <v-btn
          v-if="showSaveButton"
          color="white--text"
          @click="saveAndClose"
          :class="['menu-button', 'main', 'main-small']"
        >
          FILTER GO!
          <!-- <v-icon>search</v-icon> -->
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import matchSearchMixin from '../../mixins/match-search';

export default {
  name: 'trainer-search-team-settings',

  mixins: [matchSearchMixin],

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    showSaveButton: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
